import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { MigrateInstallationsQueryParams } from '@vi-iot/client';

import { AppState } from '../app.state';

import { MigrationStatus } from './installations-migration.model';
import { InstallationsMigrationState } from './installations-migration.state';

export namespace InstallationsMigrationSelectors {
  export const installationsMigration = (state: AppState): InstallationsMigrationState =>
    state.installationsMigration;

  export function getState(): MemoizedSelector<
    AppState,
    InstallationsMigrationState,
    DefaultProjectorFn<InstallationsMigrationState>
  > {
    return createSelector(installationsMigration, (state: InstallationsMigrationState) => state);
  }

  export function getCustomerNumber(): MemoizedSelector<
    AppState,
    string,
    DefaultProjectorFn<string>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) => state.customerNumber
    );
  }

  export function getNewCustomerNumber(): MemoizedSelector<
    AppState,
    string,
    DefaultProjectorFn<string>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) => state.newCustomerNumber
    );
  }

  export function getCustomerCompanyName(): MemoizedSelector<
    AppState,
    string,
    DefaultProjectorFn<string>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) => state.customerCompanyName
    );
  }

  export function getNewCustomerCompanyName(): MemoizedSelector<
    AppState,
    string,
    DefaultProjectorFn<string>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) => state.newCustomerCompanyName
    );
  }

  export function getInstallationsToMigrate(): MemoizedSelector<
    AppState,
    string[],
    DefaultProjectorFn<string[]>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) => state.installationsToMigrate
    );
  }

  export function getMigrationStatus(): MemoizedSelector<
    AppState,
    MigrationStatus,
    DefaultProjectorFn<MigrationStatus>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) => state.migrationStatus
    );
  }

  export function getInstallationListCursor(): MemoizedSelector<
    AppState,
    string,
    DefaultProjectorFn<string>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) => state.cursor
    );
  }

  export function getMigrateInstallationsParams(): MemoizedSelector<
    AppState,
    MigrateInstallationsQueryParams,
    DefaultProjectorFn<MigrateInstallationsQueryParams>
  > {
    return createSelector(
      installationsMigration,
      (state: InstallationsMigrationState) =>
        ({
          installationIds: state.installationsToMigrate,
          oldCompanyNumber: state.customerNumber,
          newCompanyNumber: state.newCustomerNumber,
        } as MigrateInstallationsQueryParams)
    );
  }
}
